import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  MARKETING,
  SALES,
  SERVICE,
  CMS,
  COMMERCE
} = ONBOARDING_VIEWS;
export const VIEWS_DEFAULT_ORDER = [MARKETING, SALES, SERVICE, CMS, COMMERCE];

// Order of recommended view when tasks are completed in current view
export const VIEWS_RECOMMENDED_ORDER = [SALES, MARKETING, SERVICE, CMS, COMMERCE];
export const VIEWS_RECOMMENDED_SUB_TITLES = {
  [MARKETING]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.checklist.recommended.subTitle.marketing"
  }),
  [SALES]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.checklist.recommended.subTitle.sales"
  }),
  [SERVICE]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.checklist.recommended.subTitle.service"
  }),
  [CMS]: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.checklist.recommended.subTitle.cms"
  })
};
export const VIEWS_TITLE_GETTERS = {
  [SALES]: () => I18n.text('app.tabs.sales'),
  [MARKETING]: () => I18n.text('app.tabs.marketing'),
  [SERVICE]: () => I18n.text('app.tabs.service'),
  [CMS]: () => I18n.text('app.tabs.cms'),
  [COMMERCE]: () => I18n.text('app.tabs.commerce')
};